Object.defineProperty(exports,"__esModule",{value:true});var _pick2=require("lodash/pick");var _pick3=_interopRequireDefault(_pick2);var _merge2=require("lodash/merge");var _merge3=_interopRequireDefault(_merge2);var _assign2=require("lodash/assign");var _assign3=_interopRequireDefault(_assign2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=require("react");var _react2=_interopRequireDefault(_react);
var _index=require("../victory-util/index");function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}


var defaultStyles={
fill:"#252525",
fontSize:14,
fontFamily:"'Gill Sans', 'Gill Sans MT', 'Ser­avek', 'Trebuchet MS', sans-serif",
stroke:"transparent"};var


VictoryLabel=function(_React$Component){_inherits(VictoryLabel,_React$Component);function VictoryLabel(){_classCallCheck(this,VictoryLabel);return _possibleConstructorReturn(this,(VictoryLabel.__proto__||Object.getPrototypeOf(VictoryLabel)).apply(this,arguments));}_createClass(VictoryLabel,[{key:"getStyles",value:function getStyles(






































































props){
var style=props.style?(0,_merge3.default)({},defaultStyles,props.style):defaultStyles;
var datum=props.datum||props.data;
var baseStyles=_index.Helpers.evaluateStyle(style,datum,props.active);
return(0,_assign3.default)({},baseStyles,{fontSize:this.getFontSize(baseStyles)});
}},{key:"getHeight",value:function getHeight(

props,type){
var datum=props.datum||props.data;
return _index.Helpers.evaluateProp(props[type],datum,props.active);
}},{key:"getContent",value:function getContent(

props){
if(props.text!==undefined){
var datum=props.datum||props.data;
var child=_index.Helpers.evaluateProp(props.text,datum,props.active);
return(""+child).split("\n");
}
return[" "];
}},{key:"getDy",value:function getDy(

props,content,lineHeight){
var datum=props.datum||props.data;
var dy=props.dy?_index.Helpers.evaluateProp(props.dy,datum):0;
var length=content.length;
var capHeight=this.getHeight(props,"capHeight");
var verticalAnchor=props.verticalAnchor?
_index.Helpers.evaluateProp(props.verticalAnchor,datum):"middle";
switch(verticalAnchor){
case"end":
return dy+capHeight/2+(0.5-length)*lineHeight;
case"middle":
return dy+capHeight/2+(0.5-length/2)*lineHeight;
default:
return dy+capHeight/2+lineHeight/2;}

}},{key:"getTransform",value:function getTransform(

props){
var style=this.getStyles(props);var
datum=props.datum,x=props.x,y=props.y;
var angle=props.angle||style.angle;
var transform=props.transform||style.transform;
var transformPart=transform&&_index.Helpers.evaluateProp(transform,datum);
var rotatePart=angle&&{rotate:[angle,x,y]};
return transformPart||angle?
_index.Style.toTransformString(transformPart,rotatePart):undefined;
}},{key:"getFontSize",value:function getFontSize(

style){
var baseSize=style&&style.fontSize;
if(typeof baseSize==="number"){
return baseSize;
}else if(baseSize===undefined||baseSize===null){
return defaultStyles.fontSize;
}else if(typeof baseSize==="string"){
var fontSize=+baseSize.replace("px","");
if(!isNaN(fontSize)){
return fontSize;
}else{
_index.Log.warn("fontSize should be expressed as a number of pixels");
return defaultStyles.fontSize;
}
}
return defaultStyles.fontSize;
}},{key:"renderElements",value:function renderElements(


props,content){
var transform=this.getTransform(props);
var textProps=(0,_pick3.default)(props,["dx","dy","x","y","style","textAnchor","className"]);
var fontSize=this.getFontSize(props.style);
return(
_react2.default.createElement("text",_extends({},textProps,{
transform:transform},
props.events),

content.map(function(line,i){
var dy=i?props.lineHeight*fontSize:undefined;
return(
_react2.default.createElement("tspan",{key:i,x:props.x,dy:dy,dx:props.dx},
line));


})));


}},{key:"render",value:function render()

{var _props=
this.props,datum=_props.datum,events=_props.events;
var style=this.getStyles(this.props);
var lineHeight=this.getHeight(this.props,"lineHeight");
var textAnchor=this.props.textAnchor?
_index.Helpers.evaluateProp(this.props.textAnchor,datum):"start";
var content=this.getContent(this.props);
var dx=this.props.dx?_index.Helpers.evaluateProp(this.props.dx,datum):0;
var dy=this.getDy(this.props,content,lineHeight)*style.fontSize;
var labelProps=(0,_assign3.default)(
{},this.props,{dy:dy,dx:dx,datum:datum,lineHeight:lineHeight,textAnchor:textAnchor,style:style},events);

return this.renderElements(labelProps,content);
}}]);return VictoryLabel;}(_react2.default.Component);VictoryLabel.displayName="VictoryLabel";VictoryLabel.propTypes={active:_react.PropTypes.bool,className:_react.PropTypes.string,angle:_react.PropTypes.oneOfType([_react.PropTypes.string,_react.PropTypes.number]),capHeight:_react.PropTypes.oneOfType([_react.PropTypes.string,_index.PropTypes.nonNegative,_react.PropTypes.func]),datum:_react.PropTypes.any,data:_react.PropTypes.array,index:_react.PropTypes.oneOfType([_react.PropTypes.number,_react.PropTypes.string]),events:_react.PropTypes.object,text:_react.PropTypes.oneOfType([_react.PropTypes.string,_react.PropTypes.number,_react.PropTypes.func]),lineHeight:_react.PropTypes.oneOfType([_react.PropTypes.string,_index.PropTypes.nonNegative,_react.PropTypes.func]),style:_react.PropTypes.object,textAnchor:_react.PropTypes.oneOfType([_react.PropTypes.oneOf(["start","middle","end","inherit"]),_react.PropTypes.func]),verticalAnchor:_react.PropTypes.oneOfType([_react.PropTypes.oneOf(["start","middle","end"]),_react.PropTypes.func]),transform:_react.PropTypes.oneOfType([_react.PropTypes.string,_react.PropTypes.object,_react.PropTypes.func]),x:_react.PropTypes.number,y:_react.PropTypes.number,dx:_react.PropTypes.oneOfType([_react.PropTypes.number,_react.PropTypes.string,_react.PropTypes.func]),dy:_react.PropTypes.oneOfType([_react.PropTypes.number,_react.PropTypes.string,_react.PropTypes.func])};VictoryLabel.defaultProps={capHeight:0.71,lineHeight:1};exports.default=VictoryLabel;


//////////////////
// WEBPACK FOOTER
// ./~/victory-core/lib/victory-label/victory-label.js
// module id = 585
// module chunks = 0 1